import axios from "axios"
import config from "../config"

const baseURL = config.api.url

export const setUrl = (id, rrn, consumeId) =>
  new Promise((resolve, reject) => {
    const prefix = "/api/v1"
    const url = `${baseURL + prefix}/tickets/${id}/session`
    const headers = {
      "request-reference-no": rrn,
    }
    const body = {
      // eslint-disable-next-line
      "consumeId": consumeId,
    }
    axios
      .post(url, body, { headers })
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        // console.log(error.message)
        reject(error)
      })
  })
